import logo from './logo.svg';
import './App.css';
import Intro from './components/intro';

import Aboutme from './components/aboutme';
import Projects from './components/projects';
import Navbar from './components/navbar';
import Contact from './components/contact';

function App() {
  // const { toggletheme, isLight } = useContext(ThemeContext);
  return (
    <div className="dark">
      <Navbar/>
      <Intro/>
      <Aboutme/>
      <Projects/>
      <Contact/>
    </div>
  );
}

export default App;
